import { render, staticRenderFns } from "./DatadictForTest.vue?vue&type=template&id=2db52b78&scoped=true"
import script from "./DatadictForTest.vue?vue&type=script&lang=js"
export * from "./DatadictForTest.vue?vue&type=script&lang=js"
import style0 from "./DatadictForTest.vue?vue&type=style&index=0&id=2db52b78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db52b78",
  null
  
)

export default component.exports